/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber = createReactComponent("number", "IconNumber", [
  ["path", { d: "M4 17v-10l7 10v-10", key: "svg-0" }],
  ["path", { d: "M15 17h5", key: "svg-1" }],
  [
    "path",
    { d: "M17.5 10m-2.5 0a2.5 3 0 1 0 5 0a2.5 3 0 1 0 -5 0", key: "svg-2" }
  ]
]);

export { IconNumber as default };
//# sourceMappingURL=IconNumber.js.map
